var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","overflow":"hidden"}},[_c('iframe',{staticStyle:{"height":"100%"},attrs:{"src":_vm.iurl,"frameborder":"0","width":"100%","name":_vm.$store.state.activeTab}})])
}
var staticRenderFns = []

export { render, staticRenderFns }